/**
 * Route registry for breadcrumb generation
 * Maps route paths to their display names
 * Supports dynamic segments (e.g., :id, :uuid) which will be replaced with actual values
 */
export interface RouteConfig {
  path: string;
  name: string;
  parentPath?: string; // Optional explicit parent path for breadcrumb hierarchy
}

export const routeRegistry: RouteConfig[] = [
  // Dashboard
  { path: '/dashboard', name: 'Dashboard' },
  { path: '/profile', name: 'Profile' },

  // Survey Table
  { path: '/surveys', name: 'Surveys', parentPath: '/dashboard' },

  // Submit Surveys
  {
    path: '/route-surveys/add',
    name: 'Route Survey',
    parentPath: '/dashboard',
  },
  {
    path: '/incident-reports/add',
    name: 'Incident Report',
    parentPath: '/dashboard',
  },

  // View Survey Details
  {
    path: '/route-surveys/:uuid',
    name: 'Route Survey',
    parentPath: '/surveys',
  },
  {
    path: '/incident-reports/:uuid',
    name: 'Incident Report',
    parentPath: '/surveys',
  },
  {
    path: '/customer-feedbacks/add',
    name: 'Customer Feedback',
    parentPath: '/dashboard',
  },
  {
    path: '/customer-feedbacks/:uuid',
    name: 'Customer Feedback',
    parentPath: '/surveys',
  },
  // Accounts
  { path: '/accounts', name: 'Accounts', parentPath: '/dashboard' },
  {
    path: '/accounts/add',
    name: 'Add Account',
    parentPath: '/accounts',
  },
  {
    path: '/accounts/:uuid',
    name: 'Accounts',
    parentPath: '/accounts',
  },
  {
    path: '/accounts/:uuid/edit',
    name: 'Edit',
    parentPath: '/accounts',
  },
  // Organizations
  { path: '/organizations', name: 'Organization', parentPath: '/dashboard' },
  {
    path: '/organizations/add',
    name: 'Add User',
    parentPath: '/organizations',
  },
  {
    path: '/organizations/bulk-provision',
    name: 'Bulk Provision',
    parentPath: '/organizations',
  },
  {
    path: '/organizations/:uuid',
    name: 'Organization',
    parentPath: '/organizations',
  },
  {
    path: '/organizations/:uuid/edit',
    name: 'Edit',
    parentPath: '/organizations',
  },
  {
    path: '/organizations/:uuid/profile',
    name: 'Profile',
    parentPath: '/organizations',
  },
];
